package tables.product

import emotion.react.css
import kotlinx.browser.window
import models.CategoryModel
import models.ProductModel
import org.w3c.fetch.RequestInit
import productModelToJsonString
import react.FC
import react.Props
import react.dom.html.ReactHTML.button
import react.dom.html.ReactHTML.div
import react.dom.html.ReactHTML.input
import react.dom.html.ReactHTML.option
import react.dom.html.ReactHTML.p
import react.dom.html.ReactHTML.select
import react.useEffect
import react.useState
import token
import urlAddress
import web.cssom.*
import web.html.InputType
import web.http.Headers

external interface CreateProductProps : Props {
    var isOpen: Boolean
    var listProductModel: List<ProductModel>
    var onClose: () -> Unit
    var onUpdate: () -> Unit
}

val CreateProductModal = FC<CreateProductProps> { props ->
    if (props.isOpen) {
        var productName by useState("")
        var status by useState("")
        var category by useState("")

        val (categories, setCategories) = useState(emptyList<CategoryModel>())

        fun loadCategories() {
            window.fetch(urlAddress + "api/category", RequestInit(
                method = "GET",
                headers = Headers().apply {
                    append("Authorization", "Bearer $token")
                }
            ))
                .then { response -> response.json() }
                .then { data ->
                    val newResultList = (data as? Array<dynamic> ?: emptyArray()).mapNotNull {
                        CategoryModel(
                            it.id as? Int ?: 0,
                            it.name as? String ?: "",
                            it.parent as? String ?: "",
                            it.iscategory as? Boolean ?: true,
                            it.isactive as? Boolean ?: true,

                            )
                    }
                    setCategories(newResultList)
                }
        }

        useEffect(categories.isEmpty()) {
            loadCategories()
        }

        div {
            css {
                borderRadius = 10.px
                padding = 20.px
                position = Position.fixed
                top = 50.pct
                left = 50.pct
                transform = translate((-50).pct, (-50).pct)
                backgroundColor = rgb(142, 178, 170)
                display = Display.flex
                alignItems = AlignItems.center
                justifyContent = JustifyContent.center
            }

            div {
                p {
                    +"Наименование:"
                }
                input {
                    css {
                        fontSize = 14.px
                        width = 100.pct
                    }
                    value = productName
                    type = InputType.text
                    onChange = { event ->
                        productName = event.target.value
                    }
                }
                p {
                    +"Категория:"
                }
                div {
                    select {
                        option {
                            +""
                        }
                        value = category
                        categories.filter { it.iscategory }.forEach {
                            option {
                                +it.name
                            }
                        }
                        onChange = {
                            category = it.target.value
                        }
                    }
                }
                div {
                    css {
                        paddingTop = 20.px
                        display = Display.flex
                        justifyContent = JustifyContent.spaceAround
                    }
                    button {
                        +"Сохранить"
                        disabled = ((productName.length < 3) || (category == ""))
                        onClick = {
                            window.fetch(
                                urlAddress + "api/product", RequestInit(
                                    method = "POST",
                                    headers = Headers().apply {
                                        append("Authorization", "Bearer $token")
                                        append("Content-Type", "application/json")
                                    },
                                    body = productModelToJsonString(ProductModel(0, productName, category))
                                )
                            )
                                .then { response ->
                                    if (response.ok) {
                                        props.onClose()
                                        props.onUpdate()
                                    } else {
                                        status = "Ошибка"
                                    }
                                }
                        }
                    }
                    button {
                        +"Отмена"
                        onClick = {
                            props.onClose()
                        }
                    }
                }
                p {
                    +status
                }
            }
        }
    }
}

